import { jsx as _jsx } from "react/jsx-runtime";
import { getDefaultWallets } from "../../../../../wallets/defaultWallets.js";
import { useActiveWalletChain } from "../../../../core/hooks/wallets/useActiveWalletChain.js";
import { useConnectedWallets } from "../../../../core/hooks/wallets/useConnectedWallets.js";
import { ConnectModalContent } from "../Modal/ConnectModalContent.js";
import { useSetupScreen } from "../Modal/screen.js";
export function WalletSwitcherConnectionScreen(props) {
    const walletChain = useActiveWalletChain();
    const connectedWallets = useConnectedWallets();
    const wallets = props.wallets ||
        getDefaultWallets({
            appMetadata: props.appMetadata,
            chains: props.chains,
        }).filter((w) => w.id !== "inApp");
    const screenSetup = useSetupScreen({
        size: "compact",
        welcomeScreen: undefined,
        wallets: wallets,
    });
    return (_jsx(ConnectModalContent, { accountAbstraction: props.accountAbstraction, auth: undefined, chain: props.chain || walletChain, chains: props.chains, client: props.client, connectLocale: props.connectLocale, hideHeader: props.isEmbed, isOpen: true, meta: {
            showThirdwebBranding: false,
        }, onClose: () => { }, onConnect: (w) => {
            props.onSelect(w);
            props.onBack();
        }, recommendedWallets: props.recommendedWallets, screenSetup: screenSetup, welcomeScreen: undefined, wallets: wallets, setModalVisibility: () => { }, shouldSetActive: false, showAllWallets: props.showAllWallets, size: "compact", walletConnect: props.walletConnect, modalHeader: {
            title: "Connect",
            onBack: props.onBack,
        }, walletIdsToHide: connectedWallets.map((x) => x.id) }));
}
//# sourceMappingURL=WalletSwitcherConnectionScreen.js.map